import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';

const WinterEscapeIntersector = ({ setIsWinterEscapeVisible, winterEscapeRef }) => {
    const location = useLocation()
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsWinterEscapeVisible(entry.isIntersecting);
            },
            {
                rootMargin: '-100px 0px 0px 0px', // adjust this value to fine-tune when the intersection is detected
            }
        );

        if (winterEscapeRef.current) {
            observer.observe(winterEscapeRef.current);
        }

        return () => {
            if (winterEscapeRef.current) {
                observer.unobserve(winterEscapeRef.current);
            }
        };
    }, [location]);

    return null
}

export default WinterEscapeIntersector